<!-- <ish-product-detail-actions></ish-product-detail-actions> -->
@if (product$ | async; as product) {
<div class="row product-details mt-3">
  @if ((hasSuggestedProducts$ | async) !== true) {
  <div class="col-md-6 col-xl-6 product-image-container">
    <ng-container *ngTemplateOutlet="productImages" />
  </div>
  <div class="col-md-6 col-xl-6 custom-product-right-part">
    <ng-container *ngTemplateOutlet="productDescription" />
  </div>
  } @else {
  <div class="col-xl-9 custom-quick-popup-container">
    <div class="row custom-images-container">
      <div class="col-md-6 col-lg-8 custom-images-list">
        <ng-container *ngTemplateOutlet="productImages" />
      </div>
      <div class="col-md-6 col-lg-4 custom-description-list">
        <ng-container *ngTemplateOutlet="productDescription" />
      </div>
    </div>
  </div>
  <div class="col-xl-3 custom-suggested-products-container">
    <div class="row">
      <div class="col-xl-12 pdp-suggest-prod">
        @if (links$ | async; as links) {
        <custom-suggested-for-you
          [links]="links.crossselling"
          [productLinkTitle]="'dias.product.product_links.crossselling.title' | translate"
          [displayOnlyAvailableProducts]="true"
        />
        }
      </div>
    </div>
  </div>
  }
  <ng-template #productImages>
    <ish-product-images [zoomWindowElementRef]="zoomWindowElementRef" />
    <div #zoomWindowElementRef></div>
  </ng-template>
  <ng-template #productDescription>
    <h1>
      <span itemprop="name"><ish-product-name [link]="false" /></span>
    </h1>
    <ish-lazy-product-rating />
    <div class="product-info mb-0">
      <ish-product-brand />
      <ish-product-id />
      <ish-product-promotion class="details-promotion-alinment" />
      <div class="price-container" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
        <ish-product-price [showInformationalPrice]="true" [showPriceSavings]="true" />
      </div>
      <ish-product-inventory />
      <ish-product-shipment />
      <div class="product-description mb-2" [ishServerHtml]="product.shortDescription"></div>
      <ish-product-detail-variations />
      <ish-product-warranty (submitWarranty)="setSelectedWarranty($event)" />
      <div class="bulk-order-container">
        <div class="row form-group mb-1">
          @if (quantityVisible$ | async) {
          <div class="col-12">
            <!-- <ish-product-quantity-label for="product-detail-quantity"></ish-product-quantity-label> -->
            <div class="custom-add-to-cart d-flex mb-0 pdp-buttons-padding">
              <div class="custom-add-to-cart-input mr-2 pdp-qun-btn-height">
                <ish-product-quantity id="product-detail-quantity" />
              </div>
              <div class="custom-add-to-carte-btn mb-0">
                <ish-product-add-to-basket [cssClass]="'btn-lg btn-block'" />
              </div>
            </div>
          </div>
          <div class="col-8 col-md-12">
            <custom-lazy-bulk-order />
          </div>
          } @else {
          <div class="col-8">
            <span class="mr-1"><ish-product-add-to-basket [cssClass]="'btn-lg btn-block'" /></span>
            <span class="bulk-order-button-in-pdp"><custom-lazy-bulk-order /></span>
          </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex product-action-button">
          <ish-lazy-product-add-to-order-template
            [displayType]="'icon'"
            [cssClass]="'btn btn-outline  rounded-circle btn-circle pdp-icon'"
          />
          <ish-lazy-product-send-to-compare />
          <!-- <ish-lazy-product-add-to-compare
            [displayType]="'icon'"
            [cssClass]="'btn btn-outline  rounded-circle btn-circle pdp-icon mx-2'"
            [isPDPPage]="true"
          ></ish-lazy-product-add-to-compare> -->
          <ish-lazy-product-add-to-quote
            [displayType]="'icon'"
            [cssClass]="'btn-outline rounded-circle btn-circle pdp-icon'"
          />
          <ish-lazy-product-notification-edit
            [cssClass]="'ml-2 btn-outline rounded-circle btn-circle pdp-icon'"
            [displayType]="'icon'"
          />
          <ish-lazy-product-add-to-wishlist
            [cssClass]="'ml-3 btn-outline rounded-circle btn-circle pdp-icon pl-2 pt-2'"
            [displayType]="'icon'"
          />
        </div>
      </div>
    </div>
    <div class="marketing-area">
      <ish-content-viewcontext
        viewContextId="viewcontext.include.product.productinfo"
        [callParameters]="{ Product: product.sku }"
      />
    </div>
  </ng-template>
</div>
}
